import { ElementType } from 'react';
import { Select } from 'antd';
import {
  NewLoadVisibilityFlags,
  ToggleVisibilityParams,
} from 'Shared/Types/form';
import { vehicleTypes } from "Shared/Constants";
import styles from './CustomSelect.module.scss';

const CustomSelect = ({
  field,
  fieldName,
  visibilityToggler: toggleVisibility,
  visibilityFlagValue,
  labelName,
  suffix: Suffix,
}: {
  field: any;
  fieldName: string;
  visibilityToggler: (params: ToggleVisibilityParams) => void;
  visibilityFlagValue: boolean;
  labelName?: string;
  suffix?: ElementType;
}) => {
  const flagName = fieldName as keyof NewLoadVisibilityFlags;

  return (
    <>
      {labelName && <label htmlFor={fieldName}>{labelName}</label>}
      <Select
        id={fieldName}
        className={styles.select}
        mode="multiple"
        allowClear
        open={visibilityFlagValue}
        variant='borderless'
        suffixIcon={
          Suffix ? (
            <Suffix
              className={styles.select__arrow}
              onClick={() => toggleVisibility({ flagName })}
            />
          ) : (
            ''
          )
        }
        onClick={() => toggleVisibility({ flagName })}
        {...field}
        onMouseLeave={() => toggleVisibility({ flagName, setToFalse: true })}
        options={vehicleTypes}
      />
    </>
  );
};

export default CustomSelect;
